import axios from 'axios'
import ReliableWebSocket from './ReliableWebSocket'

const getWebsocketUrl = () =>
    `ws${window.location.protocol === 'http:' ? '' : 's'}://${
        window.location.host
    }/ws`

const getAuthToken = () => {
    return (
        axios.defaults.headers.common.Authorization?.replace('Bearer ', '') ||
        ''
    )
}

const createWebSocketConfig = (dispatch, config) => {
    if (!config) {
        throw new Error('WebSocket configuration is required')
    }

    return {
        heartbeatInterval: config.heartbeat_interval * 1000,
        reconnectDelayMin: config.reconnect_delay_min,
        reconnectDelayMax: config.reconnect_delay_max,
        maxReconnectAttempts: config.max_reconnect_attempts,
        maxConsecutiveMissedPings: config.max_consecutive_missed_pings,
        pingTimeoutBufferMs: config.ping_timeout_buffer_ms,
        dispatch,
        getToken: getAuthToken,
    }
}

const createWebSocketConnection = (url, options, connectionName) => {
    const reliableWS = new ReliableWebSocket(url, {
        ...options,
        onOpen: () => console.log(`Connected to ${connectionName} WebSocket`),
        onClose: (event) =>
            console.log(
                `${connectionName} WebSocket closed:`,
                event.code,
                event.reason
            ),
        onError: (error) =>
            console.error(`${connectionName} WebSocket error:`, error),
    })

    reliableWS.connect()
    return reliableWS
}

const createMessageHandler = (actionFunc, messageValidator, errorContext) => (
    message
) => {
    try {
        if (messageValidator(message)) {
            actionFunc(message)
        }
    } catch (error) {
        console.log(`Error processing ${errorContext}:`, error)
    }
}

export const subscribeToRunbook = (runbookId, actionFunc, dispatch, config) => {
    const wsConfig = createWebSocketConfig(dispatch, config)

    return createWebSocketConnection(
        `${getWebsocketUrl()}/runbook/${runbookId}/`,
        {
            ...wsConfig,
            onMessage: createMessageHandler(
                actionFunc,
                (message) => message.actionUid || message.attrs,
                'runbook message'
            ),
        },
        `runbook (${runbookId})`
    )
}

export const subscribeToGlobal = (actionFunc, dispatch, config) => {
    const wsConfig = createWebSocketConfig(dispatch, config)

    return createWebSocketConnection(
        `${getWebsocketUrl()}/runbooks/notifications/`,
        {
            ...wsConfig,
            onMessage: createMessageHandler(
                actionFunc,
                (message) => message.payload && message.actionType,
                'global notification'
            ),
        },
        'global notifications'
    )
}
